import React, { FC } from 'react'
import { useRouter } from 'next/router'
import { ScrollDimModal } from '~/app/components'
import { OrderDetailsV3Query } from '~/__generated__/app/query/order-details/order-details.graphql'
import SelfCheckInContainer from '~/app/components/order-list/details/SelfCheckIn/SelfCheckInContainer'

/**
 * SelfCheckInModal component
 * author: soojin.oh
 */

// type definitions
type CategoryOrder = OrderDetailsV3Query['orderDetailsV3']['categoryOrders'][number]
type UserInfo = OrderDetailsV3Query['orderDetailsV3']['user']
type DomesticOrder = Extract<CategoryOrder, { __typename?: 'OrderDetailsDomestic' }>
export type SelfCheckInDomesticProps = DomesticOrder & UserInfo & { isOpened: boolean }

const TARGET_ID = 'SELF-CHECKIN'
// SelfCheckInModal component
const SelfCheckInModal: FC<SelfCheckInDomesticProps> = function ({ isOpened, ...props }) {
  const { query } = useRouter()
  const selfCheckInNumber = query.slug?.[2] || ''

  const { back } = useRouter()

  return (
    <ScrollDimModal isOpened={isOpened} targetId={TARGET_ID}>
      <SelfCheckInContainer {...props} reservationId={selfCheckInNumber} onClickBack={back} />
    </ScrollDimModal>
  )
}

export default SelfCheckInModal
